'use strict';
import {runInjector} from '../_libs/angular-utils/index';
import {injector as FileFulfillmentItemInjector} from './components/FileFulfillmentItem/FileFulfillmentItemContainer';
// eslint-disable-next-line max-len
import {injector as FileFulfillmentPendingItemInjector} from './components/FileFulfillmentPendingItem/FileFulfillmentPendingItemContainer';
import {InfoModalComponent} from './components/InfoModal/InfoModalComponent';
import {RequirementItemContainerInjector} from './components/RequirementItem/RequirementItemContainer';
import {
  AssetFileRequirementViewActivity,
  AssetFormRequirementViewActivity,
  ProjectFileRequirementViewActivity,
  ProjectFormRequirementViewActivity,
} from './components/RequirementViewActivity';
import {AssetRequirementViewFiles, ProjectRequirementViewFiles} from './components/RequirementViewFiles';
// eslint-disable-next-line max-len
import {injector as RequirementViewFilesInjector} from './components/RequirementViewFiles/RequirementViewFilesContainer';
import {AssetRequirementViewForm, ProjectRequirementViewForm} from './components/RequirementViewForm';
import {RequirementsFilesDetailsController} from './controllers/RequirementsFilesDetailsController';
import {RequirementsFilesHelper} from './controllers/RequirementsFilesHelper';
import {AbstractRequirementProvider} from './domain/AbstractRequirement';
import {AbstractFileRequirementProvider} from './domain/files/AbstractFileRequirement';
import {AssetFileRequirementDomainProvider} from './domain/files/AssetFileRequirementDomain';
import {FileAssetDomainProvider} from './domain/files/FileAssetDomain';
import {FileFulfillmentDomainProvider} from './domain/files/FileFulfillmentDomain';
import {FileRequirementDomainProvider} from './domain/files/FileRequirementDomain';
import {AssetFormRequirementDomainProvider} from './domain/forms/AssetFormRequirementDomain';
import {FormRequirementDomainProvider} from './domain/forms/FormRequirementDomain';
import {RequirementTypeDomainProvider} from './domain/RequirementTypeDomain';
import {RequirementsFilesCreateController} from './modals/RequirementsFilesCreateController';
import {injector as reqListConfigInjector} from './redux/config/reqListConfig';
import {routerAssetFileRequirementsProvider} from './router-asset-file-requirements';
import {routerAssetFormRequirementsProvider} from './router-asset-form-requirements';
import {routerProjectsFileRequirementsProvider} from './router-project-file-requirements';
import {routerProjectsFormRequirementsProvider} from './router-project-form-requirements';
import {FileRequirementEditorFactory} from './services/FileRequirementEditorFactory';
import {RequirementCreateModals} from './services/RequirementCreateModals';


const angular = require('angular');

module.exports = angular
  .module('app.requirements', [])

  .constant('AssetFileRequirementViewActivity', AssetFileRequirementViewActivity)
  .constant('AssetFormRequirementViewActivity', AssetFormRequirementViewActivity)

  .constant('ProjectFileRequirementViewActivity', ProjectFileRequirementViewActivity)
  .constant('ProjectFormRequirementViewActivity', ProjectFormRequirementViewActivity)

  .constant('AssetRequirementViewFiles', AssetRequirementViewFiles)
  .constant('ProjectRequirementViewFiles', ProjectRequirementViewFiles)

  .constant('AssetRequirementViewForm', AssetRequirementViewForm)
  .constant('ProjectRequirementViewForm', ProjectRequirementViewForm)

  .run(FileFulfillmentItemInjector)
  .run(FileFulfillmentPendingItemInjector)
  .run(runInjector(InfoModalComponent))
  .run(RequirementItemContainerInjector)
  .run(RequirementViewFilesInjector)
  .run(reqListConfigInjector)
  .config(routerAssetFileRequirementsProvider)
  .config(routerAssetFormRequirementsProvider)
  .config(routerProjectsFileRequirementsProvider)
  .config(routerProjectsFormRequirementsProvider)

  .provider('$$AbstractRequirement', AbstractRequirementProvider)
  .provider('RequirementTypeDomain', RequirementTypeDomainProvider)
  .provider('$$AbstractFileRequirement', AbstractFileRequirementProvider)
  .provider('AssetFileRequirementDomain', AssetFileRequirementDomainProvider)
  .provider('FileAssetDomain', FileAssetDomainProvider)
  .provider('FileFulfillmentDomain', FileFulfillmentDomainProvider)
  .provider('FileRequirementDomain', FileRequirementDomainProvider)
  .provider('AssetFormRequirementDomain', AssetFormRequirementDomainProvider)
  .provider('FormRequirementDomain', FormRequirementDomainProvider)

  .factory('FileRequirementEditorFactory', FileRequirementEditorFactory)
  .service('requirementCreateModals', RequirementCreateModals)

  .controller('RequirementsFilesDetailsController', RequirementsFilesDetailsController)
  .service('requirementsFilesHelper', RequirementsFilesHelper)

  .controller('RequirementsFilesCreateController', RequirementsFilesCreateController)
;



// WEBPACK FOOTER //
// ./src/js/requirements/index.js